export default {
  closeDelay: 0,
  popoverProps: {
    css: {
      padding: "4px 12px",
    },
  },
}
